import { formatBytes } from "~/shared/tools/fileUtils";
export class QFileWidget {
  constructor(el, mimetypes, messages, uploadQueue, Emitter, maxSize) {
    let index = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    this.indexFilefield = index;
    this.uploadQueue = uploadQueue;
    this.$dropzoneContent = el;
    this.$dropzoneContent.dataset.active = "1";

    // DOM-идентификаторы
    this.inputId = el.dataset.input_id || false;
    this.loaderNameId = el.dataset.loader_name_id || false;
    this.listNameId = el.dataset.list_name_id || false;
    this.cartNameId = el.dataset.cart_name_id || false;
    this.messageId = el.dataset.message_id || false;
    this.fileDropzoneType = el.dataset.dropzone_type || "0";
    this.maxCountFiles = parseInt(el.dataset.max_count_files) || 1;

    // Состояние
    this.files = [];
    this.maxSize = maxSize;
    this.mimetypes = mimetypes;
    this.Emitter = Emitter;
    this.messages = messages;
  }
  toHtml() {
    this.$dropzoneContent.innerHTML = this.generateDropzoneHTML();

    // Сохраняем ссылки на элементы
    this.$filesCounter = document.getElementById(`${this.inputId}_count-files`);
    this.$fileList = document.getElementById(this.listNameId);
    this.$btnClearAll = document.getElementById(`${this.inputId}_clear-btn`);
    if (this.$btnClearAll) {
      this.$btnClearAll.setAttribute("disabled", true);
      this.addCloseAllBtnListener();
    }
    this.computeOverallFilesSize();
    this.addCloseBtnsListeners(this.files);
    this.getFilePreview();
  }
  generateDropzoneHTML() {
    return `
      <div class="info-bar">
        <div class="size-files-box">
          <span id="${this.inputId}_count-files">
            ${this.files.length}/${this.maxCountFiles} ${this.messages.files}
          </span>
          <span class="size-files" id="${this.inputId}_size-files"></span>
        </div>
        <button class="qform-file-clear-btn" id="${this.inputId}_clear-btn" data-clear="full">
          ${this.messages.clear}
        </button>
      </div>
      <ul class="file-list" id="${this.listNameId}">
        ${this.getFileListHTML(this.files)}
      </ul>
    `;
  }
  getFileListHTML(files) {
    return files.map(file => {
      const isStackView = this.fileDropzoneType === "0";
      const fileId = file.id;
      const fileSize = this.formatSize(file.size);
      const fileNameWithoutExt = file.name.replace(/\.[^.]+$/, "");
      const fileExtension = file.name.split(".").pop();
      if (isStackView) {
        return `
          <li class="file-item-stack" id="${this.cartNameId}_${fileId}" data-size="${file.size}" data-id="${fileId}">
            <div class="file-list__img">
              <div class="file-list__progress" id="${this.loaderNameId}_${fileId}">
                <div class="progress__value animate">⏳</div>
                <div class="progress__scale"></div>
              </div>
              <img id="${this.inputId}_prev_${fileId}" alt>
              <div id="${this.inputId}_prev_ext_${fileId}" class="qform-preview-extension"></div>
            </div>
            <span class="file-list__name" id="filename_${fileId}">
              ${fileNameWithoutExt} <br>
              <span class="file-list__ext" id="filesize_${fileId}">
                (${fileSize})
              </span>
            </span>
            <div class="file-list__close" id="${this.inputId}_clear_${fileId}" data-clear="${fileId}"></div>
          </li>
        `;
      } else {
        return `
          <li class="file-item-cart" id="${this.cartNameId}_${fileId}" data-size="${file.size}" data-id="${fileId}">
            <span class="file-list__name" id="filename_${fileId}">${fileNameWithoutExt}</span>
            <span class="file-list__ext" id="filesize_${fileId}">${fileExtension}</span>
            <div class="file-list__progress" id="${this.loaderNameId}_${fileId}">
              <div class="progress__value">⏳</div>
              <div class="progress__scale"></div>
            </div>
            <div class="file-list__close" id="${this.inputId}_clear_${fileId}" data-clear="${fileId}">×</div>
          </li>
        `;
      }
    }).join("");
  }
  change() {
    const input = this.$inputFile;
    if (!input) return;
    if (input.dataset.reset === "1") {
      input.dataset.reset = "0";
      this.files = [];
    }
    const hasFiles = input.files.length > 0;
    const hasExistingFiles = this.files.length > 0;
    if (!hasFiles && !hasExistingFiles) {
      this.$dropzoneContent.style.display = "none";
      return;
    }
    this.$dropzoneContent.style.display = "block";
    const newFiles = this.formFilesList();
    if (hasFiles && !hasExistingFiles) {
      this.files = newFiles;
      this.toHtml();
    } else if (hasFiles) {
      this.files = this.files.concat(newFiles);
      this.$fileList.insertAdjacentHTML("beforeend", this.getFileListHTML(newFiles));
      this.addCloseBtnsListeners(newFiles);
      this.computeOverallFilesSize();
      this.setFilesCount();
      this.getFilePreview();
    }
    this.checkFiles();
    this.emitUploadButtonActiveState();
    this.emitFilesCount();
    this.Emitter.emit("Change:field", {});
  }
  formFilesList() {
    const files = Array.from(this.$inputFile.files);
    return files.filter(file => !this.files.some(f => f.name === file.name)).map((file, i) => ({
      name: file.name,
      size: file.size,
      file: file,
      extension: file.name.split(".").pop(),
      id: String(file.lastModified) + String(file.size) + i
    }));
  }
  checkFiles() {
    this.files.forEach(file => {
      if (!file.file.isValidFileSize || !file.file.isValidMimtype) {
        this.setFileInfoAttentionColor(file.id);
        this.showCloseFileBtn(file.id);
        this.removeFileLoader(file.id);
      }
    });
  }
  clearFile(e) {
    e.preventDefault();
    const clearId = e.target.dataset.clear;
    if (!clearId) return;
    if (clearId === "full") {
      this.handleClearAll();
    } else {
      this.handleClearSingle(clearId);
    }
  }
  handleClearAll() {
    this.uploadQueue = [];
    this.files = [];
    this.$inputFile.value = "";
    this.$inputFile.dispatchEvent(new Event("change"));
    this.Emitter.emit(`full-cleared-${this.inputId}`);
    this.emitUploadButtonActiveState();
    this.emitFilesCount();
  }
  handleClearSingle(fileId) {
    const fileToDelete = this.files.find(file => file.id === fileId);
    if (!fileToDelete) return;
    const fileElement = document.querySelector(`#${this.cartNameId}_${fileToDelete.id}`);
    fileElement?.remove();
    this.files = this.files.filter(file => file.id !== fileId);
    this.$inputFile.value = "";
    if (this.files.length > 0) {
      this.computeOverallFilesSize();
      this.setFilesCount();
    } else {
      this.$dropzoneContent.style.display = "none";
      this.Emitter.emit(`full-cleared-${this.inputId}`);
    }
    this.emitUploadButtonActiveState();
    this.emitFilesCount();
    this.Emitter.emit(`deleted-${this.inputId}`, {
      id: fileToDelete.id,
      filename: fileToDelete.name,
      size: fileToDelete.size
    });
  }
  getFilePreview() {
    this.files.forEach(file => {
      const imgPreview = document.getElementById(`${this.inputId}_prev_${file.id}`);
      const imgExtPreview = document.getElementById(`${this.inputId}_prev_ext_${file.id}`);
      if (file.file.isValidMimtype) {
        const reader = new FileReader();
        reader.readAsDataURL(file.file);
        reader.onload = () => {
          if (imgPreview) {
            imgPreview.onerror = () => {
              imgPreview.hidden = true;
              if (imgExtPreview) {
                imgExtPreview.innerHTML = file.extension;
                imgExtPreview.classList.add(file.extension);
              }
            };
            imgPreview.src = reader.result;
          }
        };
        reader.onerror = console.error;
      } else {
        if (this.fileDropzoneType === "0") {
          if (imgPreview) imgPreview.classList.add("qform-file-error");
        } else {
          const itemCard = document.getElementById(`${this.cartNameId}_${file.id}`);
          if (itemCard) itemCard.classList.add("qform-file-error");
        }
        this.setFileInfoAttentionColor(file.id);
        this.Emitter.emit("loaded", file.id);
      }
    });
  }
  setFileInfoAttentionColor(fileId) {
    const filename = document.getElementById(`filename_${fileId}`);
    const filesize = document.getElementById(`filesize_${fileId}`);
    if (filename) filename.classList.add("qform-file-error");
    if (filesize) filesize.classList.add("qform-file-error");
  }
  formatSize(bytes) {
    const units = [this.messages.b, this.messages.kb, this.messages.mb, this.messages.gb, this.messages.tb, this.messages.pb];
    return formatBytes(bytes, 2, units);
  }

  // === Подсчёт общего размера ===
  computeOverallFilesSize() {
    const totalSize = this.files.reduce((sum, file) => sum + file.size, 0);
    const sizeElement = document.getElementById(`${this.inputId}_size-files`);
    if (sizeElement) sizeElement.innerHTML = this.formatSize(totalSize);
  }

  // === Обновление счётчика файлов ===
  setFilesCount() {
    if (this.$filesCounter) {
      this.$filesCounter.innerText = `${this.files.length}/${this.maxCountFiles} ${this.messages.files}`;
    }
  }

  // === Подписка на события ===
  addListener() {
    this.$inputFile?.addEventListener("change", this.change.bind(this));
  }
  addCloseBtnsListeners(files) {
    files.forEach(file => {
      const btn = document.getElementById(`${this.inputId}_clear_${file.id}`);
      if (btn) {
        btn.addEventListener("click", e => this.clearFile(e));
        btn.style.display = "none";
      }
    });
  }
  addCloseAllBtnListener() {
    if (this.$btnClearAll) {
      this.$btnClearAll.addEventListener("click", this.clearFile.bind(this));
      this.Emitter.subscribe(`unlock-clear-all-${this.inputId}`, () => {
        this.$btnClearAll.removeAttribute("disabled");
      });
    }
  }

  // === Эмит событий ===
  emitUploadButtonActiveState() {
    this.Emitter.emit(`toggle-upload-btn-${this.inputId}`, this.files.length >= this.maxCountFiles);
  }
  emitFilesCount() {
    this.Emitter.emit(`files-count-${this.inputId}`, this.files.length);
  }

  // === Утилиты для UI ===
  removeFileLoader(id) {
    const progressBar = this.$fileList?.querySelector(`li[data-id="${id}"] .file-list__progress`);
    if (progressBar) progressBar.style.display = "none";
  }
  showCloseFileBtn(fileId) {
    const btn = document.getElementById(`${this.inputId}_clear_${fileId}`);
    if (btn) btn.style.display = "block";
  }

  // === Инициализация подписок ===
  init() {
    if (!this.inputId) return;
    this.$inputFile = document.getElementById(this.inputId);
    if (!this.$inputFile) return;
    this.addListener();

    // Загрузка завершена
    this.Emitter.subscribe("loaded", fileId => {
      this.removeFileLoader(fileId);
      this.showCloseFileBtn(fileId);
    });

    // Ошибка сервера
    this.Emitter.subscribe("server-error", filename => {
      const file = this.files.find(f => f.name === filename);
      if (file) {
        this.setFileInfoAttentionColor(file.id);
        this.showCloseFileBtn(file.id);
        this.removeFileLoader(file.id);
      }
    });

    // Ошибка сети
    this.Emitter.subscribe("network-error", () => {
      this.files.forEach(file => {
        this.setFileInfoAttentionColor(file.id);
        this.showCloseFileBtn(file.id);
        this.removeFileLoader(file.id);
      });
    });

    // Прогресс загрузки
    this.Emitter.subscribe("progress", data => {
      const progressBar = this.$fileList?.querySelector(`li[data-id="${data.id}"] .file-list__progress`);
      if (!progressBar) return;
      const valueEl = progressBar.querySelector(".progress__value");
      const scaleEl = progressBar.querySelector(".progress__scale");
      valueEl.classList.remove("animate");
      valueEl.innerHTML = Math.floor(data.progress) + "%";
      scaleEl.style.height = data.progress + "%";
    });
  }
}